import * as yup from "yup";
import i18next from "config/i18next";
import { PreliquidationAmountForm } from "./types";
import { PreliquidationCorrection } from "reducers/types/preliquidation";

const validateAmount = (
  value: number | undefined,
  increase: boolean,
  manualCorrection: PreliquidationCorrection
) => {
  if (!value) return true;

  if (value < 0) return false;
  if (value > manualCorrection.maxAllowedPlus && increase) return false;
  if (value > manualCorrection.maxAllowedSubtract && !increase) return false;

  return true;
};

export const validationSchema = (
  increase: boolean,
  manualCorrection: PreliquidationCorrection
): yup.SchemaOf<PreliquidationAmountForm> =>
  yup.object({
    actualAmount: yup.string(),
    newAmount: yup
      .mixed()
      .test(
        "rangeError",
        i18next.t("editPresettlement:amountExceededError"),
        (values) => validateAmount(values, increase, manualCorrection)
      )
      .test(
        "newAmountRequired",
        i18next.t(i18next.t("validations:required")),
        (value: number | undefined) => !!value
      ),
    reason: yup.string().required(i18next.t("validations:required")),
  });
